import { apiSlice } from '../../../api/common/apiSlice';
import { toQueryParams } from '../../../utils/request';
import { FetchLedgerJournalsRequest, FetchLedgerJournalsResponse } from '../../../types/ledgerJournal';

export const journalBrowserApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchLedgerJournals: builder.query<FetchLedgerJournalsResponse, FetchLedgerJournalsRequest>({
      query: ({ segment, params }) => ({
        url: `/admin/ledger/journals/${segment.toLowerCase()}?${toQueryParams(params)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchLedgerJournalsQuery } = journalBrowserApiSlice;
